import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { clearProject, selectCurrentProjectId, setProjectId } from '../store/slices/projectSlice';

export const useProjectRedux = () => {
  const dispatch = useAppDispatch();
  const projectId = useAppSelector(selectCurrentProjectId);

  const setProject = useCallback(
    (id: string | null) => {
      dispatch(setProjectId(id));
    },
    [dispatch]
  );

  const clearProjectState = useCallback(() => {
    dispatch(clearProject());
  }, [dispatch]);

  return {
    projectId,
    setProject,
    clearProject: clearProjectState,
  };
};

// Helper hook to get just the project ID
export const useCurrentProjectId = () => {
  return useAppSelector(selectCurrentProjectId);
};
